import React from 'react';
import classnames from 'classnames';
import { Table, TableProps, TableColumn } from 'tea-component';
import ReportCard from '../../../components/ReportCard';
import { getRecordKeyOfMockable } from '@gp/utils/common';
import { CARD_TITLE, getColumnsReadonly } from './utils';
import { DPS_REPORT_MODULE_KEY } from '../../constants';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportMemoPendingApprovalVO } from '@gp/types/dpsReport/v3';

interface IReviewMemoPendingApprovalProps extends IBaseProps, Omit<TableProps, 'columns'> {
  showGRDate?: boolean;
  reportId?: string;
  // 标题
  title?: string;
  // 模块数据
  value: IDPSReportMemoPendingApprovalVO[];
}

const ReviewMemoPendingApproval: React.FC<IReviewMemoPendingApprovalProps> = (props) => {
  const { style, className, showGRDate, reportId, title, value: records } = props;

  const columns: TableColumn<IDPSReportMemoPendingApprovalVO>[] = getColumnsReadonly({
    showGRDate,
    reportId,
  });
  return (
    <ReportCard
      style={style}
      className={classnames('dbg-dps-report__hightlights-table-card', className)}
      moduleKey={DPS_REPORT_MODULE_KEY.MEMO}
      title={title || CARD_TITLE}
    >
      <Table
        style={style}
        className={classnames(
          'dbg-table-vertical-align-top dbg-dps-report__boeder-table dbg-dps-report__hightlights-table-card dbg-dps-report-memo-pending-approval-table',
          className,
        )}
        columns={columns}
        records={records}
        recordKey={getRecordKeyOfMockable}
      />
    </ReportCard>
  );
};

export default ReviewMemoPendingApproval;
